const BD_SequenceHistory = {
  data: null,
  set: (argData) => (BD_SequenceHistory.data = argData),
}
